import { CTACard } from '../shared-components/CTACard';
import { NumberedList } from '../shared-components/NumberedList';
import { AccordionStep, ProgressAccordionStepProps } from '../shared-components/AccordionStep';
import { SimplifiedUserRole, ProgressStepStatusEnum } from '@platform/client/schemas';
import { useState } from 'react';
import {
  DiscoveryCallUpdateModal,
  DiscoveryModalDataProps,
} from '../../dashboard/my-projects/Modals/DiscoveryCallUpdateModal';
import { DISCOVERY_GUIDE_URL, HubExternalLink } from '../shared-components/HubExternalLink';

export const Discovery = ({
  status,
  userType,
  discoveryModalData,
}: ProgressAccordionStepProps & { discoveryModalData: DiscoveryModalDataProps }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const listItems = [
    <p>
      {`Reach out to the ${userType === SimplifiedUserRole.PROFESSIONAL ? 'organization' : 'professional'} by email to schedule your 30-minute call. You can reply to your introduction email or use the contact details listed on this page.`}
    </p>,
    <p>
      Use the&nbsp;
      <HubExternalLink url={DISCOVERY_GUIDE_URL}>Discovery Call Guide</HubExternalLink>
      &nbsp;during your conversation. Its questions and prompts help you both understand the
      challenge and decide if this is the right match.
    </p>,
    <p>After the call, provide an update to move to the next step.</p>,
  ];

  return (
    <>
      <AccordionStep title='Discovery' status={status}>
        <div className='flex flex-col gap-4'>
          <p>🤝 You're connected!</p>
          <p>
            It's time to schedule your Discovery Call. This first conversation is focused on seeing
            if it's a good fit, not planning the project. You'll get to know each other and decide
            whether to move forward.
          </p>
          <div>
            <h3 className='text-md font-semibold mb-2'>Steps for Your Discovery Call</h3>
            <NumberedList items={listItems} />
          </div>
          <CTACard
            title='Is it a match?'
            description="Provide an update and we'll move you to the next step. You can also update us if the scheduling is delayed or if you need more help."
            ctaButtonProps={{
              size: 'sm',
              children: 'Provide update',
              variant: 'primary',
              onPress: () => setModalIsOpen(true),
              isDisabled: status !== ProgressStepStatusEnum.active_in_progress,
            }}
          />
        </div>
      </AccordionStep>
      {modalIsOpen && (
        <DiscoveryCallUpdateModal {...discoveryModalData} onClose={() => setModalIsOpen(false)} />
      )}
    </>
  );
};
